/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 
        'Nous utilisons des témoins uniquement pour faire le suivi des visites sur notre site web et ne conservons aucune donnée personnelle.',
    cookiesAccept: 'Accepter les témoins',
    cookiesDeny: 'Refuser les témoins',
    tabFAQs: 'Questions',
    tabSupport: 'Soutien',
    tabHistory: 'L’aventure',
    tabReviews: 'Histoires',
    tabTraining: 'Formation',
    tabUserTraining: 'Formation utilisateurs',
    tabHcpTraining: 'Formation pro-santé',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Grossesse',
    tabAbout: 'À propos',
    tabNews: 'Actualités',
    tabCareers: 'Carrières',
    tabOrders: '',
    tabNotifications: 'Notifications',
};
